import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

import Button from 'components/Shared/Button'
import SettingsFormField from 'components/Shared/Forms/SettingsFormField'
import SettingsModalField from 'components/Shared/Forms/SettingsModalField'
import {
  isMaliciousHTML,
  containsLink,
  NO_LINK_MESSAGE,
  MALICIOUS_ERROR_MESSAGE,
} from '../../../utils/validation'

const validate = data => {
  const errors = {}

  if (isMaliciousHTML(data.name)) {
    errors.name = MALICIOUS_ERROR_MESSAGE
  }

  if (containsLink(data.name)) {
    errors.name = NO_LINK_MESSAGE
  }

  return errors
}

class TeamNameForm extends Component {
  render() {
    const { dirty, submitting, handleSubmit, disabled, hasTeamSwitcher } =
      this.props

    const formFieldComponent = hasTeamSwitcher
      ? SettingsModalField
      : SettingsFormField

    return (
      <form onSubmit={handleSubmit}>
        <Field
          autoComplete="off"
          component={formFieldComponent}
          name="name"
          label="Team Name"
          disabled={disabled}
        />
        {dirty ? (
          <div className="settings-form-inline-submit tight">
            <Button disabled={submitting}>Save</Button>
          </div>
        ) : null}
      </form>
    )
  }
}

export default reduxForm({
  form: 'teamSettings',
  validate,
  enableReinitialize: true,
})(TeamNameForm)
